/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Elevation {
  export class ElevationChallengeController {

    password: string = '';
    userName: string = '';
    message: string = '';
    note: string = '';
    isElevated: boolean = false;

    static $inject = [
      
      "$mdDialog",
      "meevo.AppSettings",      
      "meevo.components.common.DataService",
      "$translate",
      "requestedSecurityKeys",
      "displayName",
      "userNameFor",
      "securityKeyPath"
    ];

    constructor(
      private $mdDialog: angular.material.IDialogService,
      private appSettings: Meevo.Components.Common.IAppSettings,      
      private dataService: Meevo.Components.BaseClasses.IDataService,
      private $translate: angular.translate.ITranslateService, 
      private requestedSecurityKeys: string[],
      private displayName: string,
      private userNameFor: string,
      private securityKeyPath: string
    ) {

    }

    

    elevate(): void {
        this.message = '';
        this.note = '';
        this.isElevated = false;
        let request = {
            "userName": this.userName,
            "password": this.password ,
            "elevatedKeys": this.requestedSecurityKeys
        };
        if (this.userNameFor == this.userName) {
            this.isElevated = false;
            this.message = this.$translate.instant('LABEL_ELEVATION_CHALLENGE_CANNOT_ELEVATE_YOURSELF');
        }else{

        this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/security/elevate/`,'POST', request)
            .then((response) => {
                this.message = this.$translate.instant('LABEL_ELEVATION_CHALLENGE_SUCCESS_MESSAGE');
                this.note = this.$translate.instant('LABEL_ELEVATION_CHALLENGE_SUCCESS_NOTE');
                this.isElevated = true;
                

            }, (reason) => {
                if(Model.Guard.isSomething(reason.data) && Model.Guard.isSomething(reason.data.responseStatus) && Model.Guard.isSomething(reason.data.responseStatus.message))
                    this.message = reason.data.responseStatus.message;
                else {
                    this.message = this.$translate.instant('LABEL_ELEVATION_CHALLENGE_ERROR');
                }
            });
        }
    }

    close() {
        //hide returns the promise with the value
      return this.$mdDialog.hide(this.isElevated);
    }
           

    cancel() {
        this.isElevated = false;
        this.message = '';
        // Request for custom audit
        this.dataService.customMethodData(`/${this.appSettings.API_ROOT}/security/elevate/cancel`, 'POST', { "elevatedKeys": this.requestedSecurityKeys });
        //cancel returns the promise with the value
        return this.$mdDialog.cancel(this.isElevated);
    }
    
  }

  angular.module("meevo")
    .controller("meevo.elevation.ElevationChallengeController", ElevationChallengeController);
}

